export default __webpack_public_path__ + "static/media/IMG26.196857b5.jpeg";